import BaseApiRequest from "./BaseApiRequest";
import { OTP_VERIFY_INVITE_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class OtpVerifyInvite extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  url = OTP_VERIFY_INVITE_URL;

  constructor(reqData) {
    super();

    this.body = reqData;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
